module.exports = __webpack_public_path__ + "static/media/archive.4987e780.svg";